import { withAuth } from 'hoc';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = (props) => {
  const { component: Component, isAuthed, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthed ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
  isAuthed: PropTypes.bool.isRequired,
};

export default withAuth(PrivateRoute);
